'use strict';

import slugify from 'slugify';




const searchForm = document.querySelector('.search-form');
const searchInput = searchForm.querySelector('input.search');
const autocomplete = document.querySelector('.search-autocomplete');

let selectedIndex = -1;
let keywords = [];



function sanitizeValueForUrl (value) {
  return value
    .split('-')
    .map(v => {
      return slugify(v, {
        replacement: ' ',
        lower: true,
        locale: 'nl',
        strict: true,
      });
    })
    .join('-');
}


// Search

function doSearch ( value ) {
    const language = window.sLanguage === 'nl' ? '/' : `/${window.sLanguage}/`;
    const searchValue = sanitizeValueForUrl(value);

    window.location.replace(`${language}zoeken/${searchValue}`);
}

searchForm.addEventListener('submit', evt => {
    evt.preventDefault();

    if ( selectedIndex > -1 && keywords[selectedIndex] ) {
        doSearch(keywords[selectedIndex]);
    } else {
        doSearch(searchInput.value.replace('/', ' '));
    }
});





// Autocomplete

function fetchKeywords ( value ) {
    const searchValue = sanitizeValueForUrl(value);
    const keywordUrl = '/ajax/SearchKeyWords/get/' + searchValue;

    return fetch(keywordUrl);
}

function fillAutocompleteKeyword ( keyword ) {
    const li = document.createElement('li');

    li.classList.add('autocomplete-keyword');
    li.innerHTML = keyword;

    li.addEventListener('click', _ => doSearch(keyword));

    return li;
}

function fillAutocomplete ( fetchedKeywords ) {
    keywords = fetchedKeywords;

    const autocompleteList = keywords.map(fillAutocompleteKeyword);

    autocomplete.innerHTML = '';

    autocompleteList.forEach( keywordElem => autocomplete.append(keywordElem));

    autocomplete.classList.add('active');
    searchForm.classList.add('autocomplete');

    window.addEventListener('click', evt => {
        if ( evt.target.closest('.search-autocomplete') === null ) {
            closeAutoComplete();
        }
    }, { once: true });
}

function closeAutoComplete () {
    autocomplete.classList.remove('active');
    searchForm.classList.remove('autocomplete');
}

function setKeywordHighlight ( newIndex ) {
    if ( newIndex > -1 && keywords.length > newIndex ) {
        selectedIndex = newIndex;
    }

    autocomplete.querySelectorAll('.autocomplete-keyword')
        .forEach( (elem, index) => {
            if ( index === selectedIndex ) {
                elem.classList.add('selected');
                searchInput.value = elem.innerHTML;
            } else {
                elem.classList.remove('selected');
            }
        });
}

searchInput.addEventListener('keyup', evt => {
    const searchValue = searchInput.value;

    // Don't autocomplete single characters
    if ( searchValue.length <= 1 ) return;

    if ( evt.which === 38 ) {
        // Arrow up
        setKeywordHighlight(selectedIndex-1);
    } else if (evt.which === 40) {
        // Arrow down
        setKeywordHighlight(selectedIndex+1);
    } else {
        fetchKeywords(searchValue)
            .then(r => r.json())
            .then(fillAutocomplete);
    }
});
